(() => {
  if (window.AmbitionLoading) return;
  let resolveReady, timer;
  const ready = new Promise(resolve => { resolveReady = resolve; });
  const root = document.documentElement;
  const api = window.AmbitionLoading = {
    ready,
    phase: 'loading',
    progress: 0,
    reason: null,
    reveal(reason = 'assets') {
      if (api.phase !== 'loading') return;
      api.phase = 'revealing';
      api.reason = reason;
      document.dispatchEvent(new CustomEvent('ambition:reveal', { detail: { reason } }));
    },
    complete(reason = 'assets') {
      if (api.phase === 'ready') return;
      api.reveal(reason);
      api.phase = 'ready';
      api.reason = reason;
      clearTimeout(timer);
      root.classList.remove('ambition-is-loading');
      const screen = document.querySelector('[data-loading-screen]');
      if (screen) screen.hidden = true;
      resolveReady({ reason });
      document.dispatchEvent(new CustomEvent('ambition:ready', { detail: { reason } }));
    },
    skip(reason = 'interaction') { api.complete(reason); }
  };
  if (matchMedia('(prefers-reduced-motion:reduce)').matches || document.hidden) {
    api.complete('reduced-or-hidden');
    return;
  }
  root.classList.add('ambition-is-loading');
  timer = setTimeout(() => api.complete('timeout'), 3200);
  addEventListener('pageshow', event => { if (event.persisted) api.complete('bfcache'); });
})();
